import React, { useEffect, useState } from 'react'
import { I18nProvider } from '@lingui/react';
import { useMappedState, useDispatch } from 'redux-react-hook';
import { getSelectedLanguage } from 'store/modules/app/selectors';
import { updateI18nValues } from 'store/modules/app/actions';
import i18n from 'config/i18n';

const mapState = state => ({
  language: getSelectedLanguage(state),
});

export default function I18nLoader({ children }) {
  const { language } = useMappedState(mapState);
  const [catalogs, setCatalogs] = useState({});

  useEffect(() => {
    if (!catalogs[language]) {
      import(/* webpackMode: "lazy", webpackChunkName: "i18n-[index]" */ `config/i18n/${language}/messages.js`)
        .then(ctlg => {
          const loadedCatalogs = {
            ...catalogs,
            [language]: ctlg,
          };

          setCatalogs(loadedCatalogs);
          i18n.load(loadedCatalogs);
          i18n.activate(language);
        });
    } else {
      i18n.activate(language);
    }
  }, [language]);

  if (!catalogs[language]) {
    return (
      <div>Loading....</div>
    );
  }

  return (
    <I18nProvider i18n={i18n}>
      {children}
    </I18nProvider>
  )
}